<script setup lang="ts">
import ModalDialog from '@/components/common/ModalDialog.vue';

interface Props {
  static?: boolean;
}

withDefaults(defineProps<Props>(), {
  static: false,
});

const { t } = useTranslations();

const open = defineModel<boolean>({ required: true });
</script>

<template>
  <ModalDialog
    size="lg"
    v-model="open"
    contentClass="text-center"
    :static="static"
    @close="open = false"
  >
    <div data-testid="registered-domain-dialog" class="flex flex-col items-center space-y-4">
      <img class="w-full max-w-64" src="/images/cleepo/cleepo_contento.png" alt="Cleepo" />
      <h3 class="text-2xl">{{ t('cleepo.domain.registered_modal.title') }}</h3>
      <p>{{ t('cleepo.domain.registered_modal.description') }}</p>
      <div class="!mt-8 w-full space-y-2"></div>
    </div>
  </ModalDialog>
</template>

<style scoped lang="scss"></style>
